import Cookies from 'js-cookie';
import { getLanguage } from '@/lang/index';

const state = {
    language: getLanguage(),
    chatStatus: false,
    pageLoading: false
};

const getters = {
    language: state => state.language,
    chatStatus: state => state.chatStatus,
};

const mutations = {
    SET_LANGUAGE: (state, language) => {
        state.language = language;
        Cookies.set('language', language);
    },
    SET_CHATSTATUS: (state, data) => {
        state.chatStatus = data;
    },
    SET_PAGE_LOADING: (state, status) => {
        state.pageLoading = status;
    }
};

const actions = {
    setLanguage({ commit }, language) {
        commit('SET_LANGUAGE', language);
    },
    setChatStatus({ commit }, status) {
        commit('SET_CHATSTATUS', status);
    },
    setPageLoadStatus: ({ commit }, status) => {
        commit('SET_PAGE_LOADING', status);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
